function reportRuntimeError(
  type: 'window_error' | 'unhandled_rejection',
  payload: Record<string, unknown>,
) {
  console.error(
    JSON.stringify({
      level: 'error',
      surface: '@tov-plus/admin',
      type,
      ...payload,
    }),
  );
}

export function registerRuntimeErrorHandlers() {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('error', (event) => {
    reportRuntimeError('window_error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportRuntimeError('unhandled_rejection', {
      reason:
        event.reason instanceof Error
          ? event.reason.message
          : String(event.reason),
    });
  });
}
